import Ledger from "@/components/Ledger";
export default function Advances() {
  return <Ledger title="Advances & Loans" endpoint="advances" categories={[]} isAdvance />;
}
